import type { StateCreator } from "zustand";
import type { NewsFeedFiltersSlice } from "../newsFeed-filter.slice";

export type ArticleTagManagementState = {
  articleTagId: string | null;
  articleTagName: string;
  isCreateEditArticleTagModalOpen: boolean;
  isDeleteArticleTagModalOpen: boolean;
  isCreatingArticleTag: boolean;
  isDeletingArticleTag: boolean;
  isRenamingArticleTag: boolean;
};

export type ArticleTagManagementActions = {
  setArticleTagId: (articleTagId: string | null) => void;
  setArticleTagName: (articleTagName: string) => void;
  setCreateEditArticleTagModalOpen: (isOpen: boolean) => void;
  setDeleteArticleTagModalOpen: (isOpen: boolean) => void;
  resetArticleTagModalState: () => void;
};

export type ArticleTagManagementSlice = ArticleTagManagementState &
  ArticleTagManagementActions;

export const articleTagManagementInitialState: ArticleTagManagementState = {
  articleTagId: null,
  articleTagName: "",
  isCreateEditArticleTagModalOpen: false,
  isDeleteArticleTagModalOpen: false,
  isCreatingArticleTag: false,
  isDeletingArticleTag: false,
  isRenamingArticleTag: false,
};

export const createArticleTagManagementActions: StateCreator<
  NewsFeedFiltersSlice,
  [["zustand/devtools", never]],
  [],
  ArticleTagManagementActions
> = (set) => ({
  setArticleTagId: (articleTagId) =>
    set(
      { articleTagId },
      false,
      "[User] Article Tag Management: Set Article Tag ID",
    ),
  setArticleTagName: (articleTagName) =>
    set(
      { articleTagName },
      false,
      "[User] Article Tag Management: Set Article Tag Name",
    ),
  setCreateEditArticleTagModalOpen: (isOpen) =>
    set(
      { isCreateEditArticleTagModalOpen: isOpen },
      false,
      "[User] Article Tag Management: Set Create/Edit Article Tag Modal Open",
    ),
  setDeleteArticleTagModalOpen: (isOpen) =>
    set(
      { isDeleteArticleTagModalOpen: isOpen },
      false,
      "[User] Article Tag Management: Set Delete Article Tag Modal Open",
    ),
  resetArticleTagModalState: () =>
    set(
      articleTagManagementInitialState,
      false,
      "[User] Article Tag Management: Reset modal state",
    ),
});
